import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53673968"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-component p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-col-3" }
const _hoisted_3 = { style: {"font-size":"1rem"} }
const _hoisted_4 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-col-3" }
const _hoisted_7 = { style: {"font-size":"1rem"} }
const _hoisted_8 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_9 = { class: "p-col-3" }
const _hoisted_10 = { style: {"font-size":"1rem"} }
const _hoisted_11 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_12 = { class: "p-col-3" }
const _hoisted_13 = { style: {"font-size":"1rem"} }
const _hoisted_14 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_15 = { class: "p-col-3" }
const _hoisted_16 = { style: {"font-size":"1rem"} }
const _hoisted_17 = { class: "p-col-9" }
const _hoisted_18 = { class: "p-field p-input-filled p-inputgroup" }
const _hoisted_19 = { class: "p-col-3" }
const _hoisted_20 = { style: {"font-size":"1rem"} }
const _hoisted_21 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_22 = { class: "p-col-3" }
const _hoisted_23 = { style: {"font-size":"1rem"} }
const _hoisted_24 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_25 = { class: "p-col-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "inner-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormPositionTrainingTable = _resolveComponent("FormPositionTrainingTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.trainingKey.description), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.trainingKey.value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainingKey.value.value) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"]),
        (!(_ctx.trainingKey.value.value !== '' && _ctx.trainingKey.value.value !== null))
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t("Squeeze.Training.TrainingKey")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('Squeeze.Training.Region') + ' ' + _ctx.$t('Squeeze.Training.Anchor')), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.regionAnchorId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.regionAnchorId) = $event)),
          options: _ctx.allRegionAnchors,
          optionLabel: "description",
          optionValue: "id",
          onChange: _ctx.getItemFields
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("Squeeze.DocumentClasses.Table")), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.tableId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tableId) = $event)),
          options: _ctx.tables,
          loading: _ctx.loading,
          optionLabel: "description",
          optionValue: "id",
          disabled: ""
        }, null, 8, ["modelValue", "options", "loading"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("Squeeze.Training.Column")), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.itemField.columnId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemField.columnId) = $event)),
          options: _ctx.columnValues,
          optionLabel: "description",
          optionValue: "id",
          filter: true,
          autoFilterFocus: true,
          loading: _ctx.loading,
          onShow: _ctx.showDropdownOverlay
        }, null, 8, ["modelValue", "options", "loading", "onShow"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("Squeeze.Locators.Value")), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.itemField.valuePattern,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemField.valuePattern) = $event)),
            onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFocusField('itemFieldValuePattern')))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            class: "active",
            icon: "mdi mdi-auto-fix",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFocusField('itemFieldValuePattern')))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("Squeeze.Training.IgnoreSpaces")), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.itemField.valueIgnoreWhitespace,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.itemField.valueIgnoreWhitespace) = $event)),
          options: _ctx.booleanOptions,
          optionLabel: "name",
          optionValue: "id"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("Squeeze.Training.MultilineReadout")), 1)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.itemField.accumulateFoundValues,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.itemField.accumulateFoundValues) = $event)),
          options: _ctx.booleanOptions,
          optionLabel: "name",
          optionValue: "id"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_Button, {
          label: _ctx.itemField.id ? _ctx.$t('Squeeze.Training.Retrain') : _ctx.$t('Squeeze.Training.Train'),
          disabled: (!(_ctx.regionAnchorId && _ctx.itemField.columnId && _ctx.itemField.valuePattern !== '' && _ctx.itemField.valueRegion && _ctx.trainingKey.value.value !== '' && _ctx.trainingKey.value.value !== null)),
          onClick: _ctx.trainItemField
        }, null, 8, ["label", "disabled", "onClick"])
      ])
    ]),
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_FormPositionTrainingTable, {
        tableOrigin: "itemFields",
        tableData: _ctx.allItemFields,
        loading: _ctx.loading,
        tableId: _ctx.tableId,
        tables: _ctx.tables,
        onTestData: _ctx.testItemField,
        onChangeData: _ctx.changeItemField,
        onDeleteData: _ctx.deleteItemField,
        onOnMarkRegion: _ctx.onMarkRegion
      }, null, 8, ["tableData", "loading", "tableId", "tables", "onTestData", "onChangeData", "onDeleteData", "onOnMarkRegion"])
    ])
  ], 64))
}